import { ApiService } from "./src/02_utils/apiService";
import { Logger } from "./src/02_utils/logger";
import { Utils } from "./src/02_utils/utils";
import { Search } from "./src/05_components/search/search";
import { ErcasSearch } from "./bundles/ercas-search/search";

document.addEventListener('DOMContentLoaded', (event) => {
  const logger = new Logger();
  const utils = new Utils(logger);
  const apiService = new ApiService(logger);

  const searchs: NodeListOf<HTMLElement> = document.querySelectorAll('.js-search');

  searchs?.forEach((search: HTMLElement) => {
    new ErcasSearch(search, logger, utils);
  });


}, { passive: true });
